import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface BookingsTableProps {
  bookings: any[];
  formatCurrency: (amount: number) => string;
  onViewDetails: (booking: any) => void;
}

export const BookingsTable = ({ bookings, formatCurrency, onViewDetails }: BookingsTableProps) => {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Booking Date</TableHead>
            <TableHead>Property</TableHead>
            <TableHead>Guest</TableHead>
            <TableHead>Check-in</TableHead>
            <TableHead>Check-out</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {bookings?.map((booking) => (
            <TableRow key={booking.id}>
              <TableCell>
                {format(new Date(booking.created_at), "MMM d, yyyy")}
              </TableCell>
              <TableCell>{booking.property?.title}</TableCell>
              <TableCell>{booking.guest?.full_name}</TableCell>
              <TableCell>
                {format(new Date(booking.check_in_date), "MMM d, yyyy")}
              </TableCell>
              <TableCell>
                {format(new Date(booking.check_out_date), "MMM d, yyyy")}
              </TableCell>
              <TableCell>{formatCurrency(booking.total_price)}</TableCell>
              <TableCell>
                <Badge
                  variant={
                    booking.status === "confirmed"
                      ? "default"
                      : booking.status === "cancelled"
                      ? "destructive"
                      : booking.status === "completed"
                      ? "secondary"
                      : "outline"
                  }
                >
                  {booking.status}
                </Badge>
              </TableCell>
              <TableCell>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onViewDetails(booking)}
                >
                  View Details
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {(!bookings || bookings.length === 0) && (
            <TableRow>
              <TableCell colSpan={8} className="text-center py-8">
                No bookings found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};